// NGRX
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
// Models
import { QueryParamsModel } from '../../_base/crud';
import { ContactLoginHistoryModel } from '../_models/contact-login-history.model';
import {
  ContactLoginHistoryActions,
  ContactLoginHistoryActionTypes,
} from '../_actions/contact-login-history.actions';

export interface ContactsLoginHistoryState extends EntityState<ContactLoginHistoryModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedContactId: any;
  lastCreatedContact: ContactLoginHistoryModel;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  latestSuccessfullAction: any;
  error: any | null;
}

export const adapter: EntityAdapter<ContactLoginHistoryModel> =
  createEntityAdapter<ContactLoginHistoryModel>();

export const initialContactsLoginHistoryState: ContactsLoginHistoryState = adapter.getInitialState({
  contactForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedContactId: undefined,
  lastCreatedContact: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
  latestSuccessfullAction: null,
});

// tslint:disable-next-line:max-line-length
export function contactsLoginHistoryReducer(
  state = initialContactsLoginHistoryState,
  action: ContactLoginHistoryActions,
): ContactsLoginHistoryState {
  switch (action.type) {
    case ContactLoginHistoryActionTypes.ContactsLoginHistoryPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedContactId: undefined,
      };
    }
    case ContactLoginHistoryActionTypes.ContactLoginHistoryActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case ContactLoginHistoryActionTypes.ContactsLoginHistoryPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case ContactLoginHistoryActionTypes.ContactsLoginHistoryPageLoaded: {
      return adapter.addMany(action.payload.contactsLoginHistory, {
        ...initialContactsLoginHistoryState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case ContactLoginHistoryActionTypes.ThrowContactLoginHistoryError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case ContactLoginHistoryActionTypes.ClearContactLoginHistoryErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
